module.exports = __webpack_public_path__ + "img/outline-mode-comment.238dcb5f.svg";